import { useMeta } from '@nuxtjs/composition-api';
import { isEmpty } from 'lodash';
import { getArticleMetaTags } from './articleUtils';
import { mergeHeadItems } from '~/modules/common/utils/helpers';
import {
  getSchemaHead,
  generateNewsArticleSchema,
  generateWebsiteSchema,
  generateLocalBussinessSchema,
  generateArticleBreadcrumbSchema,
} from '~/modules/common/utils/schemaUtils';
import { initQuizResources } from '~/modules/quiz/utils/initQuiz';

export function useArticleMeta({ article, isAppView, isBot }) {
  useMeta(() => {
    if (isEmpty(article.value)) return;

    const { quizScripts } = initQuizResources(article.value);

    const websiteSchema = generateWebsiteSchema();
    const localBussinessSchema = generateLocalBussinessSchema();
    const articleSchema = generateNewsArticleSchema({ article: article.value });
    const breadcrumbSchema = generateArticleBreadcrumbSchema({ article: article.value });

    return mergeHeadItems(
      // article meta tags
      getArticleMetaTags(article.value, isAppView, isBot),
      // schema.org
      getSchemaHead(websiteSchema),
      getSchemaHead(localBussinessSchema),
      getSchemaHead(articleSchema),
      getSchemaHead(breadcrumbSchema),
      // quiz
      quizScripts
    );
  });
}
